Controller.$inject = [];

function Controller() {

};

export function HuiTableContainer() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            noScrolls: '<',
            noBorder: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<div class="hui hui-table-container scrollbar-dark"
                         ng-class="{ 'hide-scrolls': $huiCtrl.noScrolls,
                                     'without-border':  $huiCtrl.noBorder}"
                         ng-transclude></div>`;
        }
    }
}